module.exports = __webpack_public_path__ + "img/mul_1.de0e9a48.png";